import { useSyncExternalStore, useCallback } from 'react';
import { subscribeUser, getUserVersion, getSetting, setSetting } from '../userStore';

// Lecture/ecriture d'un setting user, synced. Lit le miroir synchrone et
// re-rend quand il change. [value, setValue], API facon useState.
export function useUserSetting(key, fallback) {
  useSyncExternalStore(subscribeUser, getUserVersion, getUserVersion);
  const value = getSetting(key, fallback);
  const set = useCallback((v) => setSetting(key, v), [key]);
  return [value, set];
}
